module.exports = __webpack_public_path__ + "img/grade.91273fe2.png";